import io from 'socket.io-client'
const socket = io('http://3.129.14.220:3000/')

export default socket
